import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "" }) => (
    <motion.div
        className={className}
        initial={{ opacity: 0, y: 32 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
    >
        {children}
    </motion.div>
);

export const Overline = ({ children }) => (
    <p className="text-xs font-semibold uppercase tracking-[0.25em] text-[#C9A962]/80 mb-4">
        {children}
    </p>
);
